export default __webpack_public_path__ + "e86f3ef5ccbc6927b96e07c90112f342.svg";